import { render, staticRenderFns } from "./EquivalencesUpdate.vue?vue&type=template&id=34fb7f35"
import script from "./EquivalencesUpdate.vue?vue&type=script&lang=js"
export * from "./EquivalencesUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports